module.exports = __webpack_public_path__ + "static/img/peopleBg.5d47e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/peopleBg.png
// module id = +69w
// module chunks = 1